module.exports = __webpack_public_path__ + "img/color_plata.691546da.svg";